import { App } from 'vue'

type Module = {
  default: ({ app }: { app: App }) => Promise<unknown>
}

const modules = import.meta.glob('./*.ts', { eager: true })

const defaultBootfiles: string[] = [
  'i18n',
  'sentry',
  'preferences',
  'axios',
  'pinia',
  'container',
  'tenant',
  'primevue',
  'router',
  'userback',
  'gtag',
  'theme',
  'apexcharts',
]

const Boot = async (app: App, bootfiles: string[] = defaultBootfiles) => {
  for (const bootfile of bootfiles) {
    const path = `./${bootfile}.ts`

    console.debug(`Booting: ${bootfile}`)

    const mod = modules[path] as Module

    if (!mod) {
      throw new Error(`Bootfile not found: ${bootfile}`)
    }

    if (!mod.default || typeof mod.default !== 'function') {
      throw new Error(`No exported default function from bootfile: ${bootfile}`)
    }

    try {
      await mod.default({ app })
    } catch (e) {
      console.error(`Error during booting ${bootfile}:`, e)
      throw new Error(`Failed to boot ${bootfile}: ${e.message}`)
    }
  }
}

export default Boot
